export default "__VITE_ASSET__b29a41b1__"